import { Autocomplete, Box, Button, MenuItem, Select, TextField, InputAdornment, IconButton, styled, Typography, ListItemText, Checkbox } from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'
import * as api from '../pages/services/api'
import Loader from '../components/Loader'
import { useNavigate } from 'react-router-dom'
import ModalCalendar from '../components/modal/ModalCalendar'
import dayjs from 'dayjs'
import moment from 'moment/moment'
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import { useDispatch, useSelector } from 'react-redux'
import camera from '../assets/icons/camera.svg'
import ModalDisableUser from '../components/modal/ModalDisableUser'
import { user_data } from 'store/authSlice'
import { menuActive } from 'store/menuSlice'
import ModalConfirmEditProfile from 'components/modal/ModalConfirmEditProfile'

function Profile() {

    // const auth = useSelector((state) => state.auth.user_data)
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const [loading, setLoading] = useState(false)

    const [gender, setGender] = useState([])
    const [titlename, setTitlename] = useState([])
    const [department, setDepartment] = useState([])
    const [usertype, setUsertype] = useState([])

    const [disease, setDisease] = useState([])
    const [optionDisease, setOptionDisease] = useState([])
    const [diseaseOther, setDiseaseOther] = useState('')

    const [openCalendar, setOpenCalendar] = useState(false)
    const [disabledDay, setDisabledDay] = useState([])

    const [data, setData] = useState({
        user_uid: '',
        image: "",
        user_type: "", //ประเภทผู้ใช้งาน
        user_type_code: "",
        pid: "", //เลขบัตรประชาชน
        sex: "", //เพศ
        title_name: "", //ยศ
        fname: "", //ชื่อ
        lname: "", //นามสกุล
        email: "",
        phone: "", //หมายเลขโทรศัพท์
        department_name: "", //สังกัด
        department_code: "",
        birthday: ""
    });

    const [uid, setUid] = useState('')

    const [isValidphone, setIsValidphone] = useState(false);
    const [isValidpid, setIsValidpid] = useState(false);

    const imgRef = useRef(null)
    const [selectedFile, setSelectedFile] = useState(null);

    const [openModalDisable, setOpenModalDisable] = useState(false)
    const [openModalConfirm, setOpenModalConfirm] = useState(false)

    useEffect(() => {
        dispatch(menuActive('บัญชีผู้ใช้'))
        profile()

        findGender()
        findTitleName()
        findUserGroup()
        findDepartmentFixToken()
        findCongenitalDisease()
    }, [])

    const handleChange = (e) => {
        const { name, value } = e.target;
        setData({ ...data, [name]: value });
    };

    const clickEditProfile = () => {
        let inform = {
            titlename: data['title_name'],
            firstname: data['fname'],
            lastname: data['lname'],
            gender: data['sex'],
            phone: data['phone'],
            dob: formatDate(data['birthday']),
            image_url: data['image'],
            email: data['email'],
            department_code: data['department_code'],
            congenital_disease_detail: {
                congenital_disease: disease,
                congenital_disease_other: disease.some(item => item.includes('อื่น ๆ')) ? `อื่น ๆ - ` + diseaseOther : null
            }
        }
        // console.log(inform)
        updateProfile(inform)
    }

    const findGender = async () => {
        setLoading(true)
        let res = await api.gender()
        setLoading(false)
        if (res) {
            if (res['data']['code'] == 200) {
                setGender(res['data']['data'])
            } else {
                //alert(res['data']['message'])
            }
        } else {
            alert('ไม่ตอบสนอง')
        }
    }

    const findTitleName = async () => {
        setLoading(true)
        let res = await api.titleName()
        setLoading(false)
        if (res) {
            if (res['data']['code'] == 200) {
                let option = []
                for (let i = 0; i < res['data']['data'].length; i++) {
                    if (res['data']['data'][i]) {
                        option.push({
                            key: res['data']['data'][i]['value'],
                            label: res['data']['data'][i]['name']
                        })
                    }
                    const unique = [...new Map(option.map((m) => [m.key, m])).values()] //กรองชื่อซ้ำ
                    // console.log(unique)
                    setTitlename(unique)
                }
            } else {
                //alert(res['data']['message'])
            }
        } else {
            alert('ไม่ตอบสนอง')
        }
    }

    const findUserGroup = async () => {
        setLoading(true)
        let res = await api.findUserGroup()
        setLoading(false)
        if (res) {
            if (res['data']['code'] == 200) {
                // console.log(res['data']['data'])
                setUsertype(res['data']['data'])
            } else {
                //alert(res['data']['message'])
            }
        } else {
            alert('ไม่ตอบสนอง')
        }
    }

    const findDepartmentFixToken = async () => {
        setLoading(true)
        let res = await api.findDepartmentFixToken()
        setLoading(false)
        if (res) {
            if (res['data']['code'] == 200) {
                let option = []
                for (let i = 0; i < res['data']['data'].length; i++) {
                    if (res['data']['data'][i]) {
                        option.push({
                            key: res['data']['data'][i]['department_code'],
                            label: res['data']['data'][i]['department_name']
                        })
                    }
                    const unique = [...new Map(option.map((m) => [m.key, m])).values()] //กรองชื่อซ้ำ
                    // console.log(unique)
                    setDepartment(unique)
                }
            } else {
                //alert(res['data']['message'])
            }
        } else {
            alert('ไม่ตอบสนอง')
        }
    }

    const findCongenitalDisease = async () => {
        setLoading(true)
        let res = await api.congenitalDisease()
        setLoading(false)
        if (res) {
            if (res['data']['code'] == 200) {
                setOptionDisease(res['data']['data'])
            } else {
                //alert(res['data']['message'])
            }
        } else {
            alert('ไม่ตอบสนอง')
        }
    }

    const formatDate = (date) => {
        var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;

        return [year, month, day].join('-');
    }

    const convertDate = (dataDate) => {
        const date = new Date(dataDate)
        const optionDate = {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
        }
        const thaiLocale = 'th-TH';
        const formattedDate = date.toLocaleDateString(thaiLocale, optionDate)

        const newDate = `${formattedDate}`
        return newDate
    }

    const updateProfile = async (data) => {
        setLoading(true)
        let res = await api.updateProfile(data)
        setLoading(false)
        if (res) {
            if (res['data']['code'] == 200) {
                // console.log(res['data'])
                alert('แก้ไขข้อมูลสำเร็จ')
                profile()
            } else {
                //alert(res['data']['message'])
            }
        } else {
            alert('ไม่ตอบสนอง')
        }
    }

    const profile = async () => {
        setLoading(true)
        let res = await api.profile()
        setLoading(false)
        if (res) {
            if (res['data']['code'] == 200) {
                let { data } = res.data
                dispatch(user_data(data))

                setSelectedFile(data?.['image_url'])
                setUid(data?.['uid'])
                setData({
                    ...data,
                    "user_uid": data?.['uid'],
                    'image': data?.['image_url'],
                    'user_type': data?.['user_type']?.['group_name'],
                    'user_type_code': data?.['user_type']?.['group_code'],
                    'title_name': data?.['titlename'],
                    'department_name': data?.['department']?.['department_name'],
                    'department_code': data?.['department']?.['department_code'],
                    'fname': data?.['firstname'],
                    'lname': data?.['lastname'],
                    'email': data?.['email'],
                    'sex': data?.['gender'],
                    'pid': data?.['card_id'],
                    'birthday': data?.['dob'],
                    'phone': data?.['phone'],
                });
                setDisease(data?.['congenital_disease_detail']?.['congenital_disease'] || [])
                setDiseaseOther(data?.['congenital_disease_detail']?.['congenital_disease_other'])
            } else {
                console.log(res['data']['message'])
            }
        } else {
            console.log('ไม่ตอบสนอง')
        }
    }

    const handleClickImage = () => {
        imgRef.current.click();
    }
    const handleChangeImage = async (event) => {
        const file = event.target.files && event.target.files[0];

        let formData = new FormData()
        formData.append('file', file)
        formData.append('file_path', `/profile/${data.user_uid}`)
        formData.append('file_source', 'profile')
        formData.append('file_name', file.name)

        setLoading(true)
        let res = await api.uploadProfile(data.user_uid, formData)
        setLoading(false)
        // if (res) {
        //     if (res['data']['code'] === 200) {
        //         // console.log(res['data']['data']['file_api_url'])
        //         setSelectedFile(res['data']['data']['file_api_url'])
        //         setData({ ...data, 'image': res['data']['data']['file_api_url'] })
        //     } else {
        //         //alert(res['data']['message'])
        //     }
        // } else {
        //     alert('ไม่ตอบสนอง')
        //     console.log(res)
        // }
        if (!res) return alert('ไม่ตอบสนอง')

        const code = res['code']
        if (code === 200) {
            setSelectedFile(res['data']['file_api_url'])
            setData({ ...data, 'image': res['data']['file_api_url'] })
        } else if (code === 403) {
            alert('รูปโปรไฟล์ รองรับไฟล์เฉพาะ .jpeg, .jpg, .png เท่านั้น')
        } else {
            console.log('error', res)
            alert('ไม่ตอบสนอง')
        }
    }

    return (
        <>
            <Loader loading={loading} />

            {openCalendar &&
                <ModalCalendar
                    onClose={() => { setOpenCalendar(false) }}
                    onSubmit={() => { setOpenCalendar(false) }}
                    value={
                        data['birthday'] ? dayjs(moment(data['birthday']['$d']).format('YYYY-MM-DD')) : dayjs(moment(new Date()).format('YYYY-MM-DD'))
                    }
                    setValue={(e) => {
                        setData({ ...data, birthday: e });
                    }}
                    disableDay={disabledDay}
                />
            }

            {openModalDisable &&
                <ModalDisableUser
                    onClose={() => { setOpenModalDisable(false) }}
                    uid={uid}
                />
            }

            {openModalConfirm &&
                <ModalConfirmEditProfile
                    onClose={() => { setOpenModalConfirm(false) }}
                    onSubmit={() => { clickEditProfile() }}
                />
            }

            <Box sx={design.container}>
                <Box sx={design.mainSection}>
                    <Box sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        fontSize: '20px',
                        "@media (max-width: 1100px)": {
                            fontSize: '16px',
                        },
                        "@media (max-width: 800px)": {
                            fontSize: '14px',
                        },
                    }}>
                        <Box sx={{
                            display: 'grid',
                            gridGap: '20px',
                            width: '700px',
                            "@media (max-width: 1100px)": {
                                width: '500px'
                            },
                            "@media (max-width: 800px)": {
                                width: '100%'
                            },
                        }}>
                            <Box sx={{
                                display: 'grid',
                                justifyItems: 'center'
                            }}>
                                {selectedFile ?
                                    <Box sx={{ position: 'relative' }}>
                                        <input
                                            type="file"
                                            ref={imgRef}
                                            style={{ display: "none" }}
                                            accept=".jpg,.jpeg,.png"
                                            onChange={(e) => {
                                                handleChangeImage(e)
                                            }}
                                        />
                                        <img
                                            style={{ width: '100px', height: '100px', borderRadius: '50%', border: '1px solid #BACCE1' }}
                                            src={data['image']}
                                            onClick={handleClickImage}
                                        />
                                        <img onClick={handleClickImage} src={camera} style={{ cursor: 'pointer', position: 'absolute', bottom: '8px', right: '5px' }} />
                                    </Box>
                                    :
                                    <Box sx={{ position: 'relative' }}>
                                        <input
                                            type="file"
                                            ref={imgRef}
                                            style={{ display: "none" }}
                                            accept=".jpg,.jpeg,.png"
                                            onChange={(e) => {
                                                handleChangeImage(e)
                                            }}
                                        />
                                        <Box
                                            sx={{ width: '100px', height: '100px', borderRadius: '50%', backgroundColor: '#BACCE1', border: '1px solid #BACCE1' }}
                                            onClick={handleClickImage}
                                        ></Box>
                                        <img onClick={handleClickImage} src={camera} style={{ cursor: 'pointer', position: 'absolute', bottom: '8px', right: '5px' }} />
                                    </Box>
                                }
                            </Box>

                            <Box>
                                <Box>ประเภทผู้ใช้งาน</Box>
                                <Select
                                    disabled
                                    size="small"
                                    fullWidth
                                    value={data['user_type_code'] || "null"}
                                    name={"user_type"}
                                    onChange={handleChange}
                                >
                                    <MenuItem value="null" disabled>
                                        เลือกประเภทผู้ใช้งาน
                                    </MenuItem>
                                    {usertype.map((i, idx) => (
                                        <MenuItem key={idx} value={i['group_code']}>{i['group_name']}</MenuItem>
                                    ))}
                                </Select>
                            </Box>

                            <Box>
                                <Box>เลขบัตรประจำตัวประชาชน</Box>
                                <TextField
                                    disabled
                                    placeholder='กรอกเลขบัตรประจำตัวประชาชน'
                                    size="small"
                                    fullWidth
                                    value={data["pid"]}
                                    name={"pid"}
                                // onChange={(e) => {
                                //     setData({ ...data, 'pid': e.target.value });
                                //     const regex = /^\d{13}$/;
                                //     setIsValidpid(regex.test(e.target.value));
                                // }}
                                // sx={{
                                //     "& .MuiOutlinedInput-root": {
                                //         "& fieldset": {
                                //             borderColor: isValidpid ? '' : 'red',
                                //         }
                                //     },
                                // }}
                                />
                            </Box>

                            <Box>
                                <Box>เพศ</Box>
                                <Select
                                    size="small"
                                    fullWidth
                                    value={data["sex"] || "null"}
                                    name={"sex"}
                                    onChange={handleChange}
                                >
                                    <MenuItem value="null" disabled>
                                        เลือกเพศ
                                    </MenuItem>
                                    {gender.map((i, idx) => (
                                        <MenuItem key={idx} value={i['value']}>{i['name']}</MenuItem>
                                    ))}
                                </Select>
                            </Box>

                            <Box>
                                <Box>สังกัด</Box>
                                <Autocomplete
                                    // disabled
                                    fullWidth
                                    size='small'
                                    options={department}
                                    value={data['department_name']}
                                    name='department_name'
                                    onChange={(e, value) => {
                                        setData({ ...data, 'department_name': value?.['label'], 'department_code': value?.['key'] });
                                    }}
                                    renderInput={(params) =>
                                        <TextField {...params}
                                            placeholder="เลือกสังกัด"
                                        />
                                    }
                                />
                            </Box>

                            <Box>
                                <Box>ยศ</Box>
                                <Autocomplete
                                    fullWidth
                                    size='small'
                                    options={titlename}
                                    value={data["title_name"]}
                                    name='title_name'
                                    onChange={(e, value) => {
                                        setData({ ...data, 'title_name': value?.['label'] });
                                    }}
                                    renderInput={(params) =>
                                        <TextField {...params}
                                            placeholder="เลือกยศ"
                                        />
                                    }
                                />
                            </Box>

                            <Box>
                                <Box sx={{ display: 'flex', gridGap: '10px' }}>
                                    <Box>ชื่อและนามสกุลที่แสดงในระบบ</Box>
                                    <Box sx={{ color: '#687982' }}>กรุณาใช้ชื่อและนามสกุลจริง</Box>
                                </Box>
                                <Box sx={{
                                    display: 'grid',
                                    gridTemplateColumns: '1fr 1fr',
                                    gridGap: '20px',
                                    "@media (max-width: 800px)": {
                                        gridTemplateColumns: '1fr',
                                    },
                                }}>
                                    <TextField
                                        placeholder="ชื่อ"
                                        size="small"
                                        fullWidth
                                        value={data["fname"]}
                                        name={"fname"}
                                        onChange={handleChange}
                                    />
                                    <TextField
                                        placeholder="นามสกุล"
                                        size="small"
                                        fullWidth
                                        value={data["lname"]}
                                        name={"lname"}
                                        onChange={handleChange}
                                    />
                                </Box>
                            </Box>

                            <Box sx={{
                                display: 'grid',
                                gridTemplateColumns: '1fr 1fr',
                                gridGap: '20px',
                                "@media (max-width: 800px)": {
                                    gridTemplateColumns: '1fr',
                                },
                            }}>
                                <Box>
                                    <Box sx={{ display: 'flex', alignItems: 'end', gridGap: '5px' }}>
                                        <Box>อีเมล</Box>
                                        <Box sx={{ fontSize: '14px', color: '#E06262' }}>(ใช้สำหรับรีเซตรหัสผ่าน)</Box>
                                    </Box>
                                    <TextField
                                        // disabled
                                        placeholder="กรอกอีเมล"
                                        size="small"
                                        fullWidth
                                        value={data["email"]}
                                        name={"email"}
                                        onChange={handleChange}
                                        error={data["email"] === ''}
                                        helperText={data["email"] === '' ? 'กรุณากรอกอีเมล' : ''}
                                    />
                                </Box>
                                <Box>
                                    <Box>เบอร์โทร</Box>
                                    <TextField
                                        InputProps={{
                                            sx: {
                                                '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button': {
                                                    display: 'none'
                                                },
                                                '& input[type=number]': {
                                                    MozAppearance: 'textfield'
                                                },
                                            }
                                        }}
                                        type='number'
                                        onFocus={(e) => e.target.addEventListener("wheel", function (e) { e.preventDefault() }, { passive: false })}
                                        placeholder="กรอกเบอร์โทร"
                                        size="small"
                                        fullWidth
                                        value={data["phone"]}
                                        name={"phone"}
                                        onChange={(e) => {
                                            setData({ ...data, 'phone': !e.target.value ? null : String(e.target.value).slice(0, 10) });
                                        }}
                                        slotProps={{ htmlInput: { maxLength: 10 } }}
                                        sx={{
                                            "& .MuiOutlinedInput-root": {
                                                "& fieldset": {
                                                    borderColor: isValidphone ? 'red' : '',
                                                }
                                            },
                                        }}
                                    />
                                </Box>
                            </Box>

                            <Box>
                                <Box>วันเกิด</Box>
                                <TextField
                                    fullWidth
                                    size='small'
                                    value={data['birthday'] === '' ? 'เลือกวันเกิด' : convertDate(data['birthday'])}
                                    InputProps={{
                                        inputProps: {
                                            readOnly: true,
                                        },
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <IconButton
                                                    onClick={() => { setOpenCalendar(true) }}
                                                >
                                                    <CalendarTodayIcon />
                                                </IconButton>
                                            </InputAdornment>
                                        )
                                    }}
                                />
                            </Box>

                            <Box>
                                <Box>ข้อมูลโรคประจำตัว (ที่ต้องใช้ยารักษา)</Box>
                                <Select
                                    size="small"
                                    fullWidth
                                    value={disease}
                                    multiple
                                    onChange={(e) => { setDisease(e.target.value) }}
                                    renderValue={(selected) => selected.join(', ')}
                                >
                                    <MenuItem value="null" disabled>เลือกโรคประจำตัว</MenuItem>
                                    {optionDisease.map((i, idx) => (
                                        <MenuItem key={idx} value={i["value"]}>
                                            <Checkbox checked={disease.indexOf(i["value"]) > -1} />
                                            <ListItemText primary={i["value"]} />
                                        </MenuItem>
                                    ))}
                                </Select>
                            </Box>
                            {disease.some(item => item.includes('อื่น ๆ')) &&
                                <Box>
                                    <TextField
                                        placeholder='โปรดระบุ'
                                        size="small"
                                        fullWidth
                                        value={diseaseOther}
                                        onChange={(e) => { setDiseaseOther(e.target.value) }}
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start"> อื่น ๆ - </InputAdornment>
                                            ),
                                        }}
                                    />
                                </Box>
                            }

                            <Box sx={{
                                display: 'grid',
                                gridGap: '20px',
                                justifyItems: 'center'
                            }}>
                                <Button
                                    variant="contained"
                                    sx={{
                                        width: "150px",
                                        "@media (max-width: 800px)": {
                                            width: "100px",
                                        },
                                    }}
                                    onClick={() => {
                                        // if (!data['user_type']) {
                                        //     return alert('กรุณาเลือกประเภทผู้ใช้งาน')
                                        // }
                                        if (!data['pid']) {
                                            return alert('กรุณากรอกเลขบัตรประจำตัวประชาชน')
                                        }
                                        if (data['pid']) {
                                            const regex = /^\d{13}$/;
                                            if (!regex.test(data['pid'])) {
                                                return alert('กรุณาตรวจสอบเลขบัตรประจำตัวประชาชน')
                                            }
                                        }
                                        if (!data['sex']) {
                                            return alert('กรุณาเลือกเพศ')
                                        }
                                        if (!data['title_name']) {
                                            return alert('กรุณาเลือกยศ')
                                        }
                                        if (!data['fname']) {
                                            return alert('กรุณากรอกชื่อ')
                                        }
                                        if (!data['lname']) {
                                            return alert('กรุณากรอกนามสกุล')
                                        }
                                        if (!data['email']) {
                                            return alert('กรุณากรอกอีเมล')
                                        }
                                        if (!data['phone']) {
                                            return alert('กรุณากรอกเบอร์โทรศัพท์')
                                        }
                                        if (data['phone']) {
                                            const regex = /^\d{10}$/;
                                            if (!regex.test(data['phone'])) {
                                                setIsValidphone(true)
                                                return alert('กรุณาตรวจสอบเบอร์โทรศัพท์')
                                            } else {
                                                setIsValidphone(false)
                                            }
                                        }
                                        if (!data['birthday']) {
                                            return alert('กรุณาเลือกวันเกิด')
                                        }
                                        if (!data['department_code']) {
                                            return alert('กรุณาเลือกสังกัด')
                                        }
                                        // if (!data['password']) {
                                        //     return alert('กรุณากรอกรหัสผ่าน')
                                        // }
                                        // if (!data['confirm_password']) {
                                        //     return alert('กรุณากรอกยืนยันรหัสผ่าน')
                                        // }

                                        // if (data['password'] !== data['confirm_password']) {
                                        //     return alert('รหัสผ่านไม่ตรงกัน')
                                        // }
                                        if (disease.length == 0) {
                                            return alert('กรุณาเลือกข้อมูลโรคประจำตัว')
                                        }
                                        if (disease.some(item => item.includes('อื่น ๆ')) && !diseaseOther) {
                                            return alert('กรุณากรอกข้อมูลโรคประจำตัวอื่นๆ')
                                        }

                                        // clickEditProfile()
                                        setOpenModalConfirm(true)
                                    }}
                                >อัพเดทข้อมูล</Button>

                                <Typography
                                    sx={{ color: '#478F96', cursor: 'pointer', textDecoration: 'underline' }}
                                    onClick={() => { navigate('/forgetPassword') }}
                                >รีเซ็ทรหัสผ่าน ?</Typography>

                                <Typography
                                    sx={{ color: '#E06262', cursor: 'pointer', textDecoration: 'underline' }}
                                    onClick={() => { setOpenModalDisable(true) }}
                                >ยกเลิกบัญชีผู้ใช้งาน</Typography>
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </Box>
        </>
    )
}

const design = {
    container: {
        display: "flex",
        bgcolor: "neutral.light",
    },
    mainSection: {
        px: { xl: 4, lg: 4, md: 4, sm: 2, xs: 2 },
        py: { xl: 4, lg: 4, md: 4, sm: 2, xs: 2 },
        width: "100%",
        height: "100%",
        overflow: "auto",
    },
};

const StyledMobileDatePicker = styled(MobileDatePicker)({
    '& .MuiTextField-root': {
        margin: '20px',
    },
    "& .MuiInputBase-input": {
        padding: '8.5px 14px'
    }
});

const DatePicker = {
    width: '100%'
}

export default Profile
